module.exports = __webpack_public_path__ + "img/face4.b2b5bdbf.jpg";